import React, { useEffect, useState } from "react";
import axios from "axios";
import { Card, Row, Col } from "react-bootstrap";
import "./Default.css";
import "../pages/DashboardPage.css";

const BASE_URL = 'https://whapi.infosware-test.in'; // Define base URL

function Home() {
  // State for counts
  const [counts, setCounts] = useState({
    totalItems: 0,
    totalTags: 0,
    totalReports: 0,
    totalWarehouses: 0,
  });

  // Fetch counts from backend
  useEffect(() => {
    const fetchCounts = async () => {
      try {
        const response = await axios.get(`${BASE_URL}/home/counts`); // Adjust the URL if needed
        setCounts(response.data);
      } catch (error) {
        console.error("Error fetching counts:", error.message);
      }
    };

    fetchCounts();
  }, []);

  // Data for Cards
  const { totalItems, totalTags, totalReports, totalWarehouses } = counts;

  return (
    <div className="container mt-4" key={window.location.pathname}>
      {/* Dashboard Title */}
      <h2 className="dashboard-title mb-4">Inventory Dashboard</h2>

      {/* Top Cards Section */}
      <Row className="mb-5">
        <Col md={3} sm={6} xs={12}>
          <Card className="summary-card text-center">
            <Card.Body>
              <h5>Total Items</h5>
              <h3>{totalItems}</h3>
            </Card.Body>
          </Card>
        </Col>
        <Col md={3} sm={6} xs={12}>
          <Card className="summary-card text-center">
            <Card.Body>
              <h5>Total Tags</h5>
              <h3>{totalTags}</h3>
            </Card.Body>
          </Card>
        </Col>
        <Col md={3} sm={6} xs={12}>
          <Card className="summary-card text-center">
            <Card.Body>
              <h5>Reports</h5>
              <h3>{totalReports}</h3>
            </Card.Body>
          </Card>
        </Col>
        <Col md={3} sm={6} xs={12}>
          <Card className="summary-card text-center">
            <Card.Body>
              <h5>Warehouses</h5>
              <h3>{totalWarehouses}</h3>
            </Card.Body>
          </Card>
        </Col>
      </Row>

      {/* Images Section */}
      <Row>
        <Col md={6} sm={12} className="mb-5">
          <div className="chart-container" style={{ backgroundImage: "url('images/warehouse1.jpg')" }}>
          </div>
        </Col>

        <Col md={6} sm={12} className="mb-2">
          <div className="chart-container" style={{ backgroundImage: "url('images/warehouse2.jpg')" }}>
          </div>
        </Col>
      </Row>
    </div>
  );
}

export default Home;
